const ViewAllEmployeeLeaves = ({ data, leaveIds, onClickFunction }) => {
  const updatedData = data.filter((each) => {
    return each?.isActive === true;
  });
  const getLeaveName = (leaveTypeId) => {
    const leaveType = leaveIds?.find((each) => each._id === leaveTypeId);
    return leaveType?.leaveCategory ? leaveType.leaveCategory : "Not Found";
  };

  const renderAllEmployeesData = () => {
    return updatedData?.map((each, index) => {
      const styling = index % 2 === 0 ? "bg-[#f7f9fa]" : "bg-[#e1eaf2]";
      const numberOfLeaveTypes = each.leaves.length;
      console.log(
        numberOfLeaveTypes,
        each.employeeName,
        "numberOfLeaveTypes",
        index
      );
      return (
        <>
          <tr
            className={`border-2 border-solid border-gray-900 ${styling} hover:bg-blue-300 cursor-pointer`}
            onClick={() => onClickFunction(each?.employeeId)}
          >
            <td
              className="border-2 border-l-solid border-gray-900"
              rowSpan={numberOfLeaveTypes + 1}
            >
              {each?.employeeName}
            </td>
            {numberOfLeaveTypes === 0 && (
              <td colSpan="6">No Leaves has Given</td>
            )}
          </tr>
          {numberOfLeaveTypes !== 0 &&
            each?.leaves?.map((eachLeave) => {
              return (
                <tr
                  className={`${styling} border-2 border-solid border-gray-900 hover:bg-blue-300`}
                >
                  <td>{getLeaveName(eachLeave?.leaveType)}</td>
                  <td>{eachLeave?.currentAvailableLeaves}</td>
                  <td>{eachLeave?.leavesObtained}</td>
                  <td>{eachLeave?.leavesAvailed}</td>
                  <td>{eachLeave?.leavesApproved}</td>
                  <td>{eachLeave?.leavesRejected}</td>
                </tr>
              );
            })}
        </>
      );
    });
  };

  return (
    <>
      {data?.length !== 0 ? (
        <table className="w-full text-center p-3 border-2 border-solid border-gray-900 rounded-xl">
          <tr className="bg-blue-300 rounded-xl">
            <th>Name</th>
            <th>Leave Type</th>
            <th>Current Available Leaves</th>
            <th>Leaves Obtained</th>
            <th>Leaves Availed</th>
            <th>Leaves Approved</th>
            <th>Leaves Rejected</th>
          </tr>
          {renderAllEmployeesData()}
        </table>
      ) : (
        <div className="text-xl font-bold self-center h-[90%] ">
          No employees are currently linked to this admin.
        </div>
      )}
    </>
  );
};

export default ViewAllEmployeeLeaves;
